import { SB } from '@play-co/replicant';
import { getLocaleConfig } from 'src/replicant/creatives/text';
import {
  getPetAssetKey,
  Species,
  speciesAssetsRatio,
  speciesChatbot,
} from './species';
import {
  createFlexMessageTemplate,
  createFlexContainer,
  createOpenGameAction,
} from './utils';
import { buildSender } from '../sender';

/**
 * Assets for new player joined message
 */
export const joinedAssets = {
  'background/friend_joined_to_game/ja':
    'private/chatbot/joined/friend_joined_to_game_ja.jpg',
  'background/friend_joined_to_game/en':
    'private/chatbot/joined/friend_joined_to_game_en.jpg',
};

/**
 * Create state message
 *
 * https://developers.line.biz/en/docs/messaging-api/flex-message-elements/
 * https://developers.line.biz/en/docs/messaging-api/using-flex-messages/
 *
 * Tools for generation of messages in flex format:
 * https://developers.line.biz/flex-simulator/
 */
export const joinedMessage = createFlexMessageTemplate(
  SB.object({
    petName: SB.string(),
    species: SB.tuple(speciesChatbot),
    locale: SB.tuple(['en', 'ja']),
  }),
  (data, payload, api) => {
    const locale = data.locale;
    const altText = getLocaleConfig(locale).joined.default.text;
    const icon: Species = api.getAssetPath(
      getPetAssetKey(data.species, 'happy'),
    ) as Species;
    const normal = api.getAssetPath(getPetAssetKey(data.species));

    const template = createFlexContainer(altText, {
      type: 'bubble',
      size: 'giga',
      action: createOpenGameAction(altText, payload),
      body: {
        type: 'box',
        layout: 'vertical',
        contents: [
          {
            type: 'image',
            url: api.getAssetPath(`background/friend_joined_to_game/${locale}`),
            size: 'full',
            aspectMode: 'cover',
            aspectRatio: '1.51:1',
            gravity: 'center',
          },
          {
            type: 'box',
            layout: 'vertical',
            position: 'absolute',
            width: '100%',
            height: '70%',
            offsetBottom: '32%',
            alignItems: 'center',
            justifyContent: 'flex-end',
            contents: [
              {
                type: 'box',
                layout: 'vertical',
                contents: [
                  {
                    type: 'image',
                    url: icon,
                    aspectRatio: speciesAssetsRatio[icon],
                    aspectMode: 'fit',
                    position: 'absolute',
                    gravity: 'bottom',
                    align: 'center',
                    size: 'full',
                  },
                ],
                position: 'absolute',
                width: '35%',
                height: '100%',
                justifyContent: 'flex-end',
                alignItems: 'center',
              },
            ],
          },
        ],
        paddingAll: '0px',
      },
    });

    // Add sender to message
    template['sender'] = buildSender({ name: data.petName, iconUrl: normal });

    return template;
  },
);
